import React from 'react';
import { Alert, Card } from 'react-bootstrap';
import type { ChangeEmergencyPreview } from '../../../types/changes';

interface Props {
  preview?: ChangeEmergencyPreview | null;
}

const ChangeEmergencyApprovalCard: React.FC<Props> = ({ preview }) => {
  const steps = preview?.steps || [];
  const missing = preview?.missing_managers || [];
  const first = steps.filter((step) => step.kind === 'requester_area');
  const fixed = steps.filter((step) => step.kind !== 'requester_area');
  const parallel = preview?.unlock_others_after_first !== false;

  return (
    <Card className="mb-4" data-testid="change-emergency-approval-card">
      <Card.Header className="fw-semibold">Quem aprova esta mudança</Card.Header>
      <Card.Body>
        {missing.length > 0 ? (
          <Alert variant="warning" className="py-2">
            Falta gestor em{' '}
            {missing
              .map((item) => {
                const name = item.group_name || `área #${item.group_id}`;
                return item.is_first ? `1ª aprovação (${name})` : name;
              })
              .join(', ')}
            . Cadastre o gestor (flag Gestor no grupo ou gestor fixo em Cadastros → Aprovação
            emergencial) para liberar quem aprova na aba <strong>Transporte</strong>.
          </Alert>
        ) : null}
        {preview?.waiting_area_name ? (
          <Alert variant="warning" className="py-2">
            Aguardando primeiro a aprovação de <strong>{preview.waiting_area_name}</strong>. Depois
            disso, as demais áreas ficam aptas
            {parallel ? ' em paralelo' : ''}.
          </Alert>
        ) : null}
        {steps.length ? (
          <div className="mb-2">
            {first.map((step) => (
              <p key={`${step.kind}-${step.group_id}`} className="mb-2">
                <strong>1º</strong> {step.group_name || `Área #${step.group_id}`}
                <span className="text-muted">
                  {' '}
                  — solicitante → grupo → gestor
                  {step.source === 'solicitante_membership' ? ' (membro do grupo)' : ''}
                </span>
              </p>
            ))}
            {fixed.length > 0 ? (
              <>
                <p className="mb-1 small text-muted">
                  {parallel
                    ? 'Depois, em paralelo (sem ordem entre elas):'
                    : 'Depois, em sequência:'}
                </p>
                <ul className="mb-0 ps-3">
                  {fixed.map((step) => (
                    <li key={`${step.kind}-${step.group_id}`}>
                      {step.group_name || `Área #${step.group_id}`}
                    </li>
                  ))}
                </ul>
              </>
            ) : null}
          </div>
        ) : (
          <p className="text-muted mb-2">
            Nenhum passo resolvido. Configure gestores e áreas em Cadastros → Aprovação emergencial.
          </p>
        )}
        <p className="text-muted small mb-0">
          Prévia do fluxo em Transporte (gerente imediato e áreas fixas). As decisões ficam na aba{' '}
          <strong>Transporte</strong>, não na aba Aprovações.
        </p>
      </Card.Body>
    </Card>
  );
};

export default ChangeEmergencyApprovalCard;
